// extracted by mini-css-extract-plugin
module.exports = {"filter-label":"filter-label"};